import { useMemo } from 'react';
import { COMMENT_FILTER_VALUES } from '../../../constants/commentFilterConstants';
const useIsCommentIconVisibleFromFilter = t0 => {
  "use memo";

  const {
    isCommenting,
    commentsFilter,
    moduleWithReply
  } = t0;
  let t1;
  bb0: {
    if (isCommenting) {
      t1 = true;
      break bb0;
    }
    if (!moduleWithReply) {
      t1 = false;
      break bb0;
    }
    switch (commentsFilter) {
      case COMMENT_FILTER_VALUES.resolved:
        {
          t1 = !!moduleWithReply.resolved;
          break bb0;
        }
      case COMMENT_FILTER_VALUES.all:
        {
          t1 = true;
          break bb0;
        }
      default:
        {
          t1 = !moduleWithReply.resolved;
        }
    }
  }
  return t1;
};
export default useIsCommentIconVisibleFromFilter;